<script setup lang="ts">
import type { ActionSet, Action, Element } from '../types'
import { spacingClasses } from '../utils/classes'
import ACActionList from './ACActionList.vue'

const props = defineProps<{
  element: ActionSet
  onAction?: (action: Action, inputs: Record<string, string>) => void
  elements?: Element[]
}>()
</script>

<template>
  <ACActionList
    :actions="props.element.actions"
    :on-action="props.onAction"
    :elements="props.elements"
    :class="spacingClasses[props.element.spacing ?? 'default']"
  />
</template>
